import * as signalR from "@microsoft/signalr";
import { getUserToken } from "../utils/tokenUtils";

const HUB_URL = process.env.REACT_APP_SIGNALR_HUB_URL || "https://service.mutfacikservices.com/orderHub";

class SignalRService {
  private connection: signalR.HubConnection | null = null;

  private buildConnection(): signalR.HubConnection {
    return new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        accessTokenFactory: () => getUserToken()?.token ?? "",
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 15000, 30000, 60000])
      .configureLogging(signalR.LogLevel.Warning)
      .build();
  }

  onreconnected(callback: (connectionId?: string) => void): void {
    if (!this.connection) return;
    this.connection.onreconnected(callback);
  }

  async start(): Promise<void> {
    if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
      return;
    }

    this.connection = this.buildConnection();

    try {
      await this.connection.start();
      console.log("[SignalR] Bağlantı kuruldu.");
    } catch (err) {
      console.error("[SignalR] Bağlantı kurulamadı:", err);
    }
  }

  async stop(): Promise<void> {
    if (this.connection) {
      await this.connection.stop();
      this.connection = null;
      console.log("[SignalR] Bağlantı kapatıldı.");
    }
  }

  // Tek parametre: on<MyType>("Event", (data) => ...)
  // Çoklu parametre: on<[string, string, string]>("Event", (a, b, c) => ...)
  on<T extends unknown[]>(event: string, callback: (...args: T) => void): void;
  on<T>(event: string, callback: (data: T) => void): void;
  on(event: string, callback: (...args: unknown[]) => void): void {
    if (!this.connection) return;
    this.connection.on(event, callback);
  }

  off(event: string): void {
    if (!this.connection) return;
    this.connection.off(event);
  }

  invoke(method: string, ...args: unknown[]): Promise<unknown> {
    if (!this.connection) return Promise.reject("SignalR bağlantısı yok.");
    return this.connection.invoke(method, ...args);
  }

  get state(): signalR.HubConnectionState | null {
    return this.connection?.state ?? null;
  }
}

const signalRService = new SignalRService();
export default signalRService;
